import useGet from './use-get'
import useCreate from './use-create'
import useGetOne from './use-get-one'
import useGetStatistics from './use-get-statistics'
import useGetProjectFiles from './use-get-project-files'
import useGetProjectMembers from './use-get-project-members'
import useGetProjectCase from './use-get-project-case'
import useUpdateProject from './use-update-project'
import useUploadProjectFile from './use-upload-project-file'
import useGetMetrics from './use-get-metrics'

const queries = {
  useGet,
  useCreate,
  useGetOne,
  useGetStatistics,
  useGetProjectFiles,
  useGetProjectMembers,
  useGetProjectCase,
  useUpdateProject,
  useUploadProjectFile,
  useGetMetrics,
}

export default queries
